/**
 * Masks an account number by showing only the last `suffix` characters.
 * Handles share IDs separated by "=" (e.g. "123456=01" → "56=01" with default suffix).
 *
 * @param accountNumber - The full account number to mask.
 * @param suffix - Number of trailing characters to show. Defaults to 4.
 *   When a share ID is present, half of `suffix` is taken from the main
 *   number and the share ID portion is always shown in full.
 */
export const maskAccountNumber = (
  accountNumber?: string,
  suffix: number = 4,
): string => {
  if (!accountNumber) {
    return "";
  }
  const accountAndShareId = accountNumber.split("=") || [""];
  const mainNumber = accountAndShareId[0];
  if (mainNumber.length <= suffix) return accountNumber;
  // show suffix if it has one, else last `suffix` of number
  return accountAndShareId.length > 1
    ? `${mainNumber.substring(mainNumber.length - (suffix - 2))}=${accountAndShareId[1]}`
    : mainNumber.substring(mainNumber.length - suffix);
};

/** @deprecated Use {@link maskAccountNumber} instead */
export const getLastFour = maskAccountNumber;

type Props = {
  accountNumber?: string;
  destinationInstitution?: string;
};

export const getDestinationAccountPreview = ({
  accountNumber,
  destinationInstitution = "Unknown Institution",
}: Props) => {
  const lastFour = getLastFour(accountNumber);
  const accountMask = lastFour ? `-**${lastFour}` : "";
  return `${destinationInstitution}${accountMask}`;
};
